<template>
	<div class="pagination-wrapper">
		<div class="text px-3 is-inline-block">{{ fromItem }} - {{ toItem }} of {{ totalAmount }}</div>
		<span 
			class="arrow material-icons is-clickable"
			:class="{ 'disabled': currentPage === 1 }" 
			@click="changePage(currentPage - 1)"
		>
			chevron_left
		</span>
		<span class="arrow material-icons is-clickable"
			:class="{ 'disabled': currentPage === totalPages }" 
			@click="changePage(currentPage + 1)"
		>
			chevron_right
		</span>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	props: {
		currentPage: {
			type: Number,
			required: true
		},
		totalAmount: {
			type: Number,
			required: true
		},
		itemsPerPage: {
			type: Number,
			default: 3
		}
	},
	computed: {
		totalPages (): number {
			return Math.ceil(this.totalAmount / this.itemsPerPage);
		},
		fromItem () {
			return (this.currentPage - 1) * this.itemsPerPage + 1;
		},
		toItem () {
			return Math.min(this.currentPage * this.itemsPerPage, this.totalAmount);
		}
	},
	methods: {
		changePage (page: number) {
			if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
				this.$emit('page-change', page);
			}
		}
	}
})
</script>

<style scoped lang="scss">
	.pagination-wrapper {
		text-align: center;
		.arrow,
		.text {
			vertical-align: middle;
		}
	
		.arrow {
			padding: 5px;
			transition: all 0.3s ease-in-out;
			&:not(.disabled):hover {
				transform: scale(1.3);
			}
			&.disabled {
				opacity: 0.5;
				pointer-events: none;
				cursor: default !important;
			}
		}
	}
</style>
